import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { getStandings } from '../../redux/selectors';
import { CurrencyDisplay } from '../../components/currencyDisplay';
import { Paper } from '../../components/paper';
import Fab from '@material-ui/core/Fab';
import AutorenewOutlined from '@material-ui/icons/AutorenewOutlined';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(function() {
    return {
        fabButton: {
            position: "fixed",
            right: 40,
            bottom: 40,
        }
    }
})

export default () => {
  let history = useHistory();
  const classes = useStyles();

  const gameList = useSelector(state => state.games);
  if (!gameList.currentGame) {
    return <Redirect to="/" />;
  }

  const standings = useSelector(state => getStandings(state));

  const getPlayerStandingElements = () => {
    return standings.map((userData, index) => {
      return (
        <Paper
          key={userData.userData.name}
          title={`#${index + 1} ${userData.userData.name}`}
          subtitle={<CurrencyDisplay value={userData.userValue} />}
        />
      );
    });
  };

  const startNewGame = () => {
      //set current game to none?
    history.push('/');
  }

  return (
    <div>
      {getPlayerStandingElements()}
      <Fab className={classes.fabButton} onClick={startNewGame} variant="extended">
        <AutorenewOutlined />
        Start New Game
      </Fab>
    </div>
  );
};
